import React from 'react';
import {Container, Grid2} from '@mui/material';
import SectionTitle from "./SectionTitle";
import ProjectCard from "./ProjectCard";

function Skills() {

    const projects = [
        {
            title: 'Remember My Medicines',
            description: 'A cross-platform app that helps young adults remember to take their medicines on time, with smart reminders and clear navigation.',
            imgPath: '/assets/images/cover-rmm.png',
            ctaRoute: '/projects/remember-my-medicines',
            skills: [
                'User Research',
                'Wireframing',
                'Usability Testing',
                'Figma',
                'Design System',
            ]
        },
        {
            title: 'Adopt Me',
            description: 'A dog adoption platform that makes it easy to find, filter, and adopt a puppy, with a fast and user-friendly process.',
            imgPath: '/assets/images/cover-adoptme.png',
            ctaRoute: '/projects/adopt-me',
            skills: [
                'User Research',
                'Wireframing',
                'Usability Testing',
                'Figma',
                'Design System',
            ]
        },
        {
            title: 'WhenItDrop',
            description: 'A web app that tracks Amazon product prices and notifies users in real-time when prices drop — with a minimal, focused interface.',
            imgPath: '/assets/images/cover.wid.png',
            ctaRoute: '/projects/when-it-drop',
            skills: [
                'User Research',
                'Wireframing',
                'Competitive Analysis',
                'Figma',
                'Design System',
            ]
        },
    ];

    return (
        <Container sx={{ padding: '64px 0',  overflow: 'hidden'}}>
            <SectionTitle title={'Projects'} />
            <Grid2 container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                {projects.map((project, index) => (
                    <Grid2 key={index} size={{ xs: 4, sm: 4, md: 4 }} sx={{display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <ProjectCard {...project}  />
                    </Grid2>
                ))}
            </Grid2>
        </Container>
    );
}

export default Skills;